import { useQuery } from "react-query";
import clientApi from "./client";
import { transactions, transferTransactions } from "./routes";

const fetchUserTransactions = async (type) => {
  const { data } = await clientApi.get(transactions(type));
  return data;
};

  

  const fetchTransferTransactions = async () => {
    const { data } = await clientApi.get(transferTransactions);
    return data;
  }

  export const useGetTransferTransactions = () => {
    return useQuery("transfer-transactions", async () => {
      const res = await fetchTransferTransactions();
      return res.data;
    })
  }
  
export const useGetUsersTransactions = (type) => {
  return useQuery(["users-transactions", type], async () => {
    const res = await fetchUserTransactions(type);
    return res.data;
  });
};
